




















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { AcgnTitle, AcgnAuditStep, AcgnUpload } from '@acgn/herm/src/ui';
import { AttributeMixin, RenderMenuMixin } from '@/mixins';
import { AcgnFormContent, AcgnFormTitle, AcgnTaskMenu, AcgnGroupEdit, AcgnApproveDetail } from '@/components/';
import { AcgnTableTask, AcgnTableTasklist } from './components/';
import { namespace } from 'vuex-class';
import { complexClone } from '@acgn/herm/src/util/serialize';
import { getComicUploadImageSts } from '@/api/ossClient';
import { displayFormValidationError } from '@acgn/herm/src/util/form';
import event from '@acgn/herm/src/util/event';
import { Tabs, TabPane } from 'element-ui';

const TaskGroupAction = namespace('desk/taskGroup').Action;

interface ComicDetailType { // 编辑结构类型
  name: string; // 名称
}

// 组件申明
@Component({
  components: {
    AcgnTitle,
    AcgnAuditStep,
    AcgnFormContent,
    AcgnFormTitle,
    AcgnTableTask,
    AcgnTableTasklist,
    AcgnUpload,
    AcgnTaskMenu,
    [Tabs.name]: Tabs,
    AcgnGroupEdit,
    AcgnApproveDetail,
    [TabPane.name]: TabPane
  },
  mixins: [AttributeMixin, RenderMenuMixin]
})

/**
 * 项目概况
 */
export default class ComicDetail extends Vue {
  @TaskGroupAction private getTaskGroupList: any; // 获取任务组列表

  private formData: ComicDetailType = {
    name: ''
  };
  private comicId: any = 0;

  private searchForm: any = { // 头部筛选项
    name: '',
    username: '',
    page: 1
  };

  private activeName: any = 'first';

  private manageGroupList: any = [
    {
      id: 1,
      name: '项目概况',
      icon: 'ift-project_2',
      url: 'desk-comicAuthDetail',
      belong: 'comicAuth',
      selected: true,
    }
  ]; // 选中的管理组


  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-task-menu authorityCode="1003" source="comic" manageGroupList={this.manageGroupList}></acgn-task-menu>
    );
  }

  // 获取表单验证规则
  private get rules() {
    const rules = {
      name: [
        { required: true, message: '标题不可为空', trigger: 'blur' }
      ]
    };

    return rules;
  }

  private async created() {
    this.comicId = this.$route.params.id;
  }

  private async getList(options: any) {
    const temp = options;
    temp.project_id = this.comicId;
    return this.getTaskGroupList(temp);
  }

  // 获取状态
  private getStadius(row: any) {
    return (
      <span class="detail-sta">已过审</span>
    );
  }

  // 返回列表
  private goBack() {
    this.$router.back();
  }
}
